import React from 'react';
import PropTypes from 'prop-types';
import objectPath from 'object-path';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import Container from '../../container';
import DetailGraphic from '../detail-graphic';
import HeroTextWave from '../../hero-text-wave';

const DetailHero = ({
  image,
  title,
  subheading,
  children,
  isDark,
  icon,
  fill,
  rotateIcon,
}) => {
  const fallback = isDark
    ? `${process.env.S3_ROOT}/w4w-static/images/project-fallback-dark.svg`
    : `${process.env.S3_ROOT}/w4w-static/images/project-fallback-light.svg`;
  const featuredImage = image && objectPath.get(image, 'photo.file.url')
    ? `${image.photo.file.url}?w=330&h=220&q=75&fit=thumb&fm=jpg&fl=progressive`
    : fallback;

  return (
    <Hero isDark={isDark}>
      <Container>

        <HeroContent>

          <HeroImage
            src={featuredImage}
            alt={`${title} featured image`}
          />

          <HeroTextWave>
            <h1>{title}</h1>
          </HeroTextWave>

          <HeroTextWave>
            <h4>{subheading}</h4>
          </HeroTextWave>

          {children}

          <HeroGraphics rotateIcon={rotateIcon}>
            <DetailGraphic icon={icon} fill={fill} />
          </HeroGraphics>
        </HeroContent>

      </Container>
    </Hero>
  );
};

const Hero = styled.section`
  padding: 435px 0 90px;
  text-align: center;
  color: ${props => props.isDark ? '#fff' : props.theme.dark};
  background-color: ${props => props.isDark ? '#073342' : '#fff'};

  ${screen.below(bp.mobile, `
    padding: 274px 0 45px;
  `)};
`;

const HeroContent = styled.div`
  position: relative;

  h1 {
    position: relative;
    z-index: 3;
  }

  h4 {
    margin: 35px 0;
  }

  svg {
    transform: translate(-50%, -50%);
  }
`;

const HeroImage = styled.img`
  max-width: 330px;
  position: absolute;
  top: -140px;
  left: 50%;
  z-index: 2;
  transform: rotate(8.6deg) translateX(-50%);

  @supports (filter: drop-shadow(24px 19px 49px rgba(0, 0, 0, .18))) {
    filter: drop-shadow(24px 19px 49px rgba(0, 0, 0, .18));
  }

  ${screen.below(bp.mobile, `
    top: -70px;
    max-width: 165px;
  `)};
`;

const HeroGraphics = styled.div`
  position: absolute;
  top: -240px;
  left: calc(50% - 160px);
  z-index: 1;
  ${props => props.rotateIcon ? 'transform: rotate(-15deg); transform-origin: 50% 50%;' : null};

  ${screen.below(bp.mobile, `
    top: -120px;
    left: calc(50% - 80px);
  `)};
`;

DetailHero.propTypes = {
  title: PropTypes.string,
  subheading: PropTypes.string,
  image: PropTypes.object,
  children: PropTypes.node,
  isDark: PropTypes.bool,
  icon: PropTypes.string,
  fill: PropTypes.string,
  rotateIcon: PropTypes.bool,
};

DetailHero.defaultProps = {
  icon: 'drop',
  fill: '#69a4b8',
};

export default DetailHero;
